/**
 * Título do CARD DE PRÉVIA do painel de artefato — nunca do `label` cru.
 *
 * `entrada.label` no `UI_REGISTRY` é, por desenho, o MESMO texto de
 * `TOOL_LABELS` do backend (`constants/Text.js`, ex.: `get_cliente_resumo:
 * 'Consultando cliente...'` — ver `CLAUDE.md` deste módulo, §13). Isso está
 * CERTO para o uso original (a linha de raciocínio "o que a IA está fazendo
 * agora"), mas vira um título esquisito e permanentemente "em andamento"
 * quando usado como texto fixo do card de prévia de um artefato já
 * RESOLVIDO — ele nunca foi pensado como título de card pronto.
 *
 * Esta função é só de EXIBIÇÃO: não mexe no contrato `label`/`TOOL_LABELS`
 * (travado por `Text.tool-labels.unit.js` e usado em outros lugares — badge,
 * raciocínio). `parteReal.label` continua levando o `label` ORIGINAL, intacto
 * — só o TÍTULO do card de prévia passa por aqui.
 *
 * Função PURA, sem I/O.
 *
 * Sem `?.`/`??` (o Babel deste projeto não transpila). Acentos UTF-8 reais.
 *
 * @param {string} label
 * @returns {string}
 */
export function tituloDoArtefato(label) {
  if (!label) return label

  const prefixo = 'consultando '
  const sufixo = '...'
  const labelMinusculo = label.toLowerCase()

  if (!labelMinusculo.startsWith(prefixo)) return label
  if (!label.endsWith(sufixo)) return label

  const meio = label.slice(prefixo.length, label.length - sufixo.length)
  if (!meio) return label

  return meio.charAt(0).toUpperCase() + meio.slice(1)
}

export default tituloDoArtefato
